<template dark>
  <div class="renderPage reporte-container animate-fade-in">
    <!-- Main Toolbar -->
    <v-toolbar color="primary" dark flat class="mb-6 rounded-xl" height="64">
      <v-icon class="mr-3" size="28">mdi-cogs</v-icon>
      <v-toolbar-title class="text-subtitle-1 text-sm-h6 font-weight-black px-0 text-uppercase letter-spacing-1">
        Configuración de Sorteos
      </v-toolbar-title>
      <v-spacer />
      <v-btn icon color="white" to="/home" class="glass-btn">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-toolbar>

    <v-container fluid>
      <!-- Glass Card 1: Límite General -->
      <v-card class="glass-card mb-6 rounded-xl overflow-hidden" elevation="0">
        <div class="px-6 py-4 border-bottom header-glass">
          <div class="d-flex align-center">
            <v-icon color="primary" class="mr-2">mdi-chart-bar</v-icon>
            <span class="text-subtitle-1 font-weight-bold primary--text">Límite General</span>
          </div>
        </div>
        <v-card-text class="pa-6">
          <v-row align="center">
            <v-col cols="12" md="4" sm="4">
              <v-select label="Grupo Sorteos" item-text="descripcion" item-value="id"
                v-model="sorteoDropDown" :items="sorteos" 
                class="modern-input" outlined dense rounded hide-details="auto"
                @change="changeSorteos"></v-select>
            </v-col>
            <v-col cols="12" sm="4" md="2">
              <v-text-field v-model="sorteoeditedItem.montoPermitido" label="Monto Máximo"
                class="modern-input" outlined dense rounded hide-details="auto" type="number"></v-text-field>
            </v-col>
            <v-col cols="12" sm="4" md="2">
              <v-btn color="primary" class="rounded-pill px-6 font-weight-bold shadow-soft w-100" height="42" @click="saveSorteos">
                <v-icon left>mdi-plus</v-icon> Agregar
              </v-btn>
            </v-col>
          </v-row>

          <!-- First Table: Límite General -->
          <v-data-table :headers="headersSorteos" :items="grupoSorteos" :search="search" class="premium-table mt-6">
            <template v-slot:top>
              <!-- Dialog Articulos (Editar) -->
              <v-dialog v-model="dialogArticulos" max-width="700px">
                <v-card class="theme-aware-dialog rounded-xl">
                  <v-toolbar color="primary" dark flat height="56">
                    <v-icon class="mr-2">mdi-pencil</v-icon>
                    <v-toolbar-title class="text-subtitle-1 font-weight-bold">Editar Sorteo</v-toolbar-title>
                  </v-toolbar>
                  <v-card-text class="pa-6">
                    <v-row>
                      <v-col cols="12" sm="3">
                        <v-text-field v-model="sorteoeditedItem.id" class="modern-input" outlined dense rounded label="Código Sorteo" readonly hide-details="auto"></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="5">
                        <v-text-field v-model="sorteoeditedItem.descripcion" class="modern-input" outlined dense rounded label="Descripción" readonly hide-details="auto"></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="4">
                        <v-text-field v-model="sorteoeditedItem.montoPermitido" class="modern-input" type="number" step="any" min="0" outlined dense rounded label="Monto Permitido" hide-details="auto"></v-text-field>
                      </v-col>
                    </v-row>
                  </v-card-text>
                  <v-divider></v-divider>
                  <v-card-actions class="pa-4">
                    <v-spacer></v-spacer>
                    <v-btn color="grey darken-1" text class="rounded-pill px-6" @click="closeDeleteSorteos">Cancelar</v-btn>
                    <v-btn color="primary" class="rounded-pill px-6 font-weight-bold shadow-soft" @click="saveDetalleArticulo">Actualizar</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
              <!-- Dialog Delete Sorteos -->
              <v-dialog v-model="dialogDelete" max-width="500px">
                <v-card class="theme-aware-dialog rounded-xl">
                  <v-card-title class="text-h6 font-weight-bold justify-center pt-6">¿Desea descartar el sorteo?</v-card-title>
                  <v-card-actions class="pa-6 justify-center">
                    <v-btn color="grey darken-1" text class="rounded-pill px-6" @click="closeDeleteSorteos">Cancelar</v-btn>
                    <v-btn color="error" class="rounded-pill px-8 font-weight-bold shadow-soft" @click="deleteItemConfirmSorteos">OK</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </template>
            <template v-slot:[`item.actions`]="{ item }">
              <v-btn icon color="primary" class="mx-1 glass-btn" @click="detalleEditItem(item)">
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
            </template>
            <template v-slot:[`item.delete`]="{ item }">
              <v-btn icon color="error" class="mx-1 glass-btn-error" @click="deleteItemSorteos(item)">
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>

      <!-- Glass Card 2: Límite por Número -->
      <v-card class="glass-card mb-6 rounded-xl overflow-hidden" elevation="0">
        <div class="px-6 py-4 border-bottom header-glass">
          <div class="d-flex align-center">
            <v-icon color="secondary" class="mr-2">mdi-numeric</v-icon>
            <span class="text-subtitle-1 font-weight-bold secondary--text">Límite por Número</span>
          </div>
        </div>
        <v-card-text class="pa-6">
          <v-row align="center">
            <v-col cols="12" md="3" sm="4">
              <v-select label="Sorteo" item-text="descripcion" item-value="id"
                v-model="sorteoLimiteDropDown" :items="sorteosLimite"
                class="modern-input" outlined dense rounded hide-details="auto"
                @change="changeSorteosLimite"></v-select>
            </v-col>
            <v-col cols="12" sm="2" md="2">
              <v-text-field v-model="sorteoLimiteeditedItem.numeros" label="Número"
                class="modern-input" outlined dense rounded hide-details="auto" type="number"></v-text-field>
            </v-col>
            <v-col cols="12" sm="3" md="2">
              <v-text-field v-model="sorteoLimiteeditedItem.montoPermitido" label="Monto Máximo"
                class="modern-input" outlined dense rounded hide-details="auto" type="number"></v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="3">
              <v-checkbox v-model="sorteoLimiteeditedItem.todos" label="Agregar a todos mis sorteos" 
                class="mt-0" hide-details="auto" color="secondary">
              </v-checkbox>
            </v-col>
            <v-col cols="12" sm="12" md="2" class="text-md-right mt-2 mt-md-0">
              <v-btn color="secondary" class="rounded-pill px-6 font-weight-bold shadow-soft w-100" height="42" @click="saveSorteosLimite">
                <v-icon left>mdi-plus</v-icon> Agregar
              </v-btn>
            </v-col>
          </v-row>

          <!-- Second Table: Límite por número -->
          <v-data-table :headers="headersSorteosLimite" :items="grupoSorteosLimite" :search="search" class="premium-table mt-6">
            <template v-slot:top>
              <!-- Dialog Delete Limite -->
              <v-dialog v-model="dialogDeleteLimite" max-width="500px">
                <v-card class="theme-aware-dialog rounded-xl">
                  <v-card-title class="text-h6 font-weight-bold justify-center pt-6">¿Desea descartar el límite?</v-card-title>
                  <v-card-actions class="pa-6 justify-center">
                    <v-btn color="grey darken-1" text class="rounded-pill px-6" @click="closeDeleteSorteosLimite">Cancelar</v-btn>
                    <v-btn color="error" class="rounded-pill px-8 font-weight-bold shadow-soft" @click="deleteItemConfirmSorteosLimite">OK</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>

              <!-- Dialog Delete Limite All -->
              <v-dialog v-model="dialogDeleteLimiteAll" max-width="500px">
                <v-card class="theme-aware-dialog rounded-xl">
                  <v-card-title class="text-h6 font-weight-bold justify-center text-center pt-6">¿Estás seguro de eliminar en todos los sorteos?</v-card-title>
                  <v-card-actions class="pa-6 justify-center">
                    <v-btn color="grey darken-1" text class="rounded-pill px-6" @click="closeDeleteSorteosLimite">Cancelar</v-btn>
                    <v-btn color="error" class="rounded-pill px-8 font-weight-bold shadow-soft" @click="deleteItemConfirmSorteosLimiteAll">OK</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </template>
            <template v-slot:[`item.delete`]="{ item }">
              <v-btn icon color="error" class="mx-1 glass-btn-error" @click="deleteItemSorteosLimite(item)">
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </template>
            <template v-slot:[`item.deleteAll`]="{ item }">
              <v-btn icon color="error" class="mx-1 glass-btn-error" @click="deleteItemSorteosLimiteAll(item)">
                <v-icon>mdi-delete-sweep</v-icon>
              </v-btn>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>

    </v-container>
    <Snackbar v-bind:text="snackText" v-bind:snackbar.sync="snackValue" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import axios from "axios";
import Snackbar from "./shared/Snackbar.vue";
//import Cabys from "./Cabys.vue";

export default {
    components: {
        Snackbar,
        //Cabys,
    },
    dark: true,
    data() {
        return {
            dialog: false,
            dialogArticulos: false,
            dialogDeleteLimite: false,
            dialogDeleteLimiteAll: false,
            valid: false,
            incluirValid: true,
            cancelarValid: false,
            eliminarValid: false,
            guardarValid: false,
            existeSorteo: false,
            existeSorteoLimite: false,
            sorteoDropDown: "",
            sorteoLimiteDropDown: "",
            formatVersion: "",
            footerText: "",
            diasLimiteCanje: 0,
            grupoSorteos: [],
            grupoSorteosLimite: [],
            tiqueteConfigs: [],
            tiqueteFooters: [],
            search: "",
            snackText: "",
            snackValue: false,
            tab2: "",
            headers: [
                {
                    text: "Cédula",
                    align: "start",
                    value: "companyId",
                },
                {
                    text: "Nombre",
                    align: "start",
                    value: "nombre",
                },
                { text: "Editar", value: "actions", width: 50, sortable: false },
            ],
            headersSorteos: [
                {
                    text: "Nombre",
                    align: "start",
                    value: "descripcion",
                },
                {
                    text: "Monto Permitido",
                    align: "start",
                    value: "montoPermitido",
                },
                { text: "Editar", value: "actions", width: 50, sortable: false },
                { text: "Eliminar", value: "delete", width: 70, sortable: false },
            ],
            headersSorteosLimite: [
                // {
                //     text: "Nombre",
                //     align: "start",
                //     value: "descripcion",
                // },
                {
                    text: "Número",
                    align: "start",
                    value: "numeros",
                },
                {
                    text: "Monto Permitido",
                    align: "start",
                    value: "montoPermitido",
                },
                { text: "Eliminar", value: "delete", width: 70, sortable: false },
                { text: "Eliminar Todos", value: "deleteAll", width: 150, sortable: false },
            ],
            items: [],
            sorteos: [],
            sorteosLimite: [],
            editedIndex: -1,
            editedItem: {
                nombre: "",
                companyId: "",
                porcPaga: 0,
                porcPagaExt: 0,
                minutosAntesCierre: 0,
                montoPermitido: 0,
                porcPagaReventando: 0,
                porcPagaReventandoX: 0,
                formatVersion: "",
                diasLimiteCanje: 0,
                footerText: "",
            },
            defaultItem: {
                nombre: "",
                companyId: "",
                porcPaga: 0,
                porcPagaExt: 0,
                minutosAntesCierre: 0,
                montoPermitido: 0,
                porcPagaReventando: 0,
                porcPagaReventandoX: 0,
                formatVersion: "",
                diasLimiteCanje: 0,
                footerText: "",
            },
            sorteoditedIndex: -1,
            sorteoeditedItem: {
                id: 0,
                descripcion: "",
                montoPermitido: 0,
            },
            sorteodefaultItem: {
                id: 0,
                descripcion: "",
                montoPermitido: 0,
            },

            sorteoLimiteeditedIndex: -1,
            sorteoLimiteeditedItem: {
                companyId: "",
                montoPermitido: 0,
                numeros: "",
                idSorteo: 0,
                todos: false,
            },
            sorteoLimitedefaultItem: {
                companyId: "",
                montoPermitido: 0,
                numeros: "",
                idSorteo: 0,
                todos: false,
            },

            tiqueteFootereditedItem: {
                value: 0,
                companyId: ""
            },
            tiqueteFooterdefaultItem: {
                value: 0,
                companyId: ""
            },

            tiqueteConfigeditedItem: {
                configKey: "",
                configValue: "",
                companyId: "",
            },
            tiqueteConfigdefaultItem: {
                configKey: "",
                configValue: "",
                companyId: "",
            },
            modeloCia: {
                cia: [],
                grupoSorteos: [],
                tiqueteConfig: [],
                tiqueteFooter: [],
            },
            modeloSorteos: {
                companyId: "",
                grupoSorteos: [],
            },
            showNewData: false,
            nameRules: [(v) => !!v || "Campo requerido"],
            tempFile: "",
            tempFileImage: "",
            modelFile: null,
            modelFileImage: null,
        };
    },

    computed: {
        ...mapGetters(["user", "strCia"]),
    },

    watch: {
        dialog(val) {
            val || this.close();
        },

        search() {
            this.snackValue = false;
        },
    },

    created() {
        this.getSorteos();
        this.getModeloCia();
        this.getSorteosAll();
        //this.getTiposIdentificacion();
    },

    methods: {
        getData() {
            let me = this;
            axios
                .get("api/Tiempos/getBancas", {
                    crossdomain: true,
                })
                .then(function (response) {
                    me.items = response.data;
                })
                .catch(function (error) {
                    console.log(error);
                });
        },

        limpiar() {
            this.snackValue = false;
        },

        getSorteos() {
            this.snackValue = false;

            let me = this;
            axios
                .get("api/Tiempos/GetGrupoSorteos")
                .then(function (response) {
                    me.sorteos = response.data;
                })
                .catch(function (error) {
                    console.log(error);
                });
        },

        getSorteosAll() {
            this.snackValue = false;
            let me = this;
            axios
                .get("api/Tiempos/GetSorteosAll?companyId=" + this.strCia)
                .then(function (response) {
                    me.sorteosLimite = response.data;
                })
                .catch(function (error) {
                    console.log(error);
                });
        },

        saveDetalleArticulo() {
            this.snackValue = false;
            if (this.sorteoeditedIndex > -1) {
                Object.assign(
                    this.grupoSorteos[this.sorteoeditedIndex],
                    this.sorteoeditedItem
                );
            } else {
                this.grupoSorteos.push(this.sorteoeditedItem);
            }

            let me = this;
            //this.editedItem.cia = this.strCia;
            this.modeloSorteos.companyId = this.strCia;
            this.modeloSorteos.grupoSorteos = this.grupoSorteos;

            axios
                .post("/api/Tiempos/UpdateSorteosCia", this.modeloSorteos)
                .then(function () {
                    me.snackText = "Registro modificado satisfactoriamente";
                    me.snackValue = true;
                    me.getSorteosAll();
                    //me.getData();
                })
                .catch(function (error) {
                    console.log(error);
                    // me.saved(false);
                });

            this.closeSorteos();
        },

        detalleEditItem(item) {
            this.snackValue = false;
            this.sorteoeditedIndex = this.grupoSorteos.indexOf(item);
            this.sorteoeditedItem = Object.assign({}, item);
            this.dialogArticulos = true;
        },

        closeDeleteSorteos() {
            this.snackValue = false;
            this.dialogDelete = false;
            this.dialogArticulos = false;
            this.$nextTick(() => {
                this.sorteoeditedItem = Object.assign({}, this.sorteodefaultItem);
                this.sorteoeditedIndex = -1;
            });
        },

        closeDeleteSorteosLimite() {
            this.snackValue = false;
            this.dialogDeleteLimite = false;
            this.dialogDeleteLimiteAll = false;
            this.$nextTick(() => {
                this.sorteoLimiteeditedItem = Object.assign({}, this.sorteoLimitedefaultItem);
                this.sorteoLimiteeditedIndex = -1;
            });
        },

        deleteItemSorteos(item) {
            this.snackValue = false;
            this.sorteoeditedIndex = this.grupoSorteos.indexOf(item);
            this.sorteoeditedItem = Object.assign({}, item);
            this.dialogDelete = true;
        },

        deleteItemSorteosLimite(item) {
            this.snackValue = false;
            this.sorteoLimiteeditedIndex = this.grupoSorteosLimite.indexOf(item);
            this.sorteoLimiteeditedItem = Object.assign({}, item);
            this.dialogDeleteLimite = true;
            this.dialogDeleteLimiteAll = false;
        },

        deleteItemSorteosLimiteAll(item) {
            this.snackValue = false;
            this.sorteoLimiteeditedIndex = this.grupoSorteosLimite.indexOf(item);
            this.sorteoLimiteeditedItem = Object.assign({}, item);
            this.dialogDeleteLimite = false;
            this.dialogDeleteLimiteAll = true;
        },

        deleteItemConfirmSorteos() {
            this.snackValue = false;
            this.grupoSorteos.splice(this.sorteoeditedIndex, 1);

            let me = this;
            //this.editedItem.cia = this.strCia;
            this.modeloSorteos.companyId = this.strCia;
            this.modeloSorteos.grupoSorteos = this.grupoSorteos;

            axios
                .post("/api/Tiempos/UpdateSorteosCia", this.modeloSorteos)
                .then(function () {
                    me.snackText = "Registro eliminado satisfactoriamente";
                    me.snackValue = true;
                    me.getSorteosAll();
                    //me.getData();
                })
                .catch(function (error) {
                    console.log(error);
                    // me.saved(false);
                });

            this.closeSorteos();

            this.closeDeleteSorteos();
        },

        deleteItemConfirmSorteosLimite() {
            this.snackValue = false;
            this.grupoSorteosLimite.splice(this.sorteoLimiteeditedIndex, 1);
            this.sorteoLimiteeditedItem.Todos = false;
            let me = this;

            axios
                .post("/api/Tiempos/DeleteLimiteNumeros", this.sorteoLimiteeditedItem)
                .then(function () {
                    me.snackText = "Registro eliminado satisfactoriamente";
                    me.snackValue = true;
                    //me.getData();
                })
                .catch(function (error) {
                    console.log(error);
                    // me.saved(false);
                });

            this.closeSorteosLimite();
        },

        deleteItemConfirmSorteosLimiteAll() {
            this.snackValue = false;
            this.grupoSorteosLimite.splice(this.sorteoLimiteeditedIndex, 1);
            this.sorteoLimiteeditedItem.Todos = true;
            let me = this;

            axios
                .post("/api/Tiempos/DeleteLimiteNumeros", this.sorteoLimiteeditedItem)
                .then(function () {
                    me.snackText = "Registros eliminados satisfactoriamente";
                    me.snackValue = true;
                    //me.getData();
                })
                .catch(function (error) {
                    console.log(error);
                    // me.saved(false);
                });

            this.closeSorteosLimite();
        },

        saveSorteos() {
            this.addNewSorteos();
        },


        saveSorteosLimite() {
            this.addNewSorteosLimite();
        },

        changeSorteos() {
            this.getSorteo();
        },

        changeSorteosLimite() {
            this.getSorteoLimite();
        },

        getSorteo() {
            this.snackValue = false;
            let me = this;
            axios
                .get("api/Tiempos/GetGrupoSorteosById?id=" + this.sorteoDropDown, {
                    crossdomain: true,
                })
                .then(function (response) {
                    me.sorteoeditedItem = response.data;
                })
                .catch(function (error) {
                    console.log(error);
                });
        },

        getSorteoLimite() {
            this.snackValue = false;
            let me = this;
            axios
                .get("api/Tiempos/GetLimiteNumerosAll?companyId=" + this.strCia + "&idSorteo=" + this.sorteoLimiteDropDown, {
                    crossdomain: true,
                })
                .then(function (response) {
                    me.grupoSorteosLimite = response.data;
                })
                .catch(function (error) {
                    console.log(error);
                });
        },

        getModeloCia() {
            this.snackValue = false;
            let me = this;
            axios
                .get("api/Tiempos/GetModeloCia?companyId=" + this.strCia, {
                    crossdomain: true,
                })
                .then(function (response) {
                    me.grupoSorteos = response.data.grupoSorteos;
                })
                .catch(function (error) {
                    console.log(error);
                });
        },

        addNewSorteos() {
            this.snackValue = false;
            this.existeSorteo = false;
            this.grupoSorteos.find((object) => {
                if (object.id === this.sorteoDropDown) {
                    this.existeSorteo = true;
                }
            });

            if (this.existeSorteo === false) {
                if (this.sorteoeditedItem.id != "") {
                    if (this.sorteoeditedIndex > -1) {
                        // this.snackText = "Existe:" + this.existeCia;
                        // this.snackValue = true;
                    } else {
                        this.grupoSorteos.push(this.sorteoeditedItem);

                        let me = this;
                        //this.editedItem.cia = this.strCia;
                        this.modeloSorteos.companyId = this.strCia;
                        this.modeloSorteos.grupoSorteos = this.grupoSorteos;

                        axios
                            .post("/api/Tiempos/UpdateSorteosCia", this.modeloSorteos)
                            .then(function () {
                                me.snackText = "Registro modificado satisfactoriamente";
                                me.snackValue = true;
                                me.getSorteosAll();
                                //me.getData();
                            })
                            .catch(function (error) {
                                console.log(error);
                                // me.saved(false);
                            });

                        this.closeSorteos();

                        this.existeSorteo = false;
                    }
                    this.closeSorteos();
                }
            }
        },

        addNewSorteosLimite() {
            this.snackValue = false;
            this.existeSorteoLimite = false;
            // this.grupoSorteosLimite.find((object) => {
            //     if (object.id === this.sorteoLimiteDropDown) {
            //         this.existeSorteoLimite = true;
            //     }
            // });

            if (this.existeSorteoLimite === false) {
                if (this.sorteoLimiteeditedItem.id != "") {
                    if (this.sorteoLimiteeditedIndex > -1) {
                        // this.snackText = "Existe:" + this.existeCia;
                        // this.snackValue = true;
                    } else {
                        this.grupoSorteosLimite.push(this.sorteoLimiteeditedItem);

                        this.sorteoLimiteeditedItem.companyId = this.strCia;
                        this.sorteoLimiteeditedItem.idSorteo = this.sorteoLimiteDropDown;

                        let me = this;
                        axios
                            .post("/api/Tiempos/InsertLimiteNumeros", this.sorteoLimiteeditedItem)
                            .then(function () {
                                me.snackText = "Registro agregado satisfactoriamente";
                                me.snackValue = true;
                                //me.getData();
                            })
                            .catch(function (error) {
                                console.log(error);
                                // me.saved(false);
                            });

                        this.closeSorteosLimite();

                        this.existeSorteoLimite = false;
                    }
                    this.closeSorteosLimite();
                }
            }
        },

        closeSorteosLimite() {
            this.snackValue = false;
            this.dialog = false;
            this.dialogArticulos = false;
            this.dialogDeleteLimite = false;
            this.dialogDeleteLimiteAll = false;
            this.$nextTick(() => {
                this.sorteoLimiteeditedItem = Object.assign({}, this.sorteoLimitedefaultItem);
                this.sorteoLimiteeditedIndex = -1;
            });
        },

        closeSorteos() {
            this.snackValue = false;
            this.dialog = false;
            this.dialogArticulos = false;
            this.$nextTick(() => {
                this.sorteoeditedItem = Object.assign({}, this.sorteodefaultItem);
                this.sorteoeditedIndex = -1;
            });
        },

        editItem(item) {
            this.snackValue = false;
            this.editedIndex = this.items.indexOf(item);
            this.editedItem = Object.assign({}, item);
            this.getSorteos();
            this.getModeloCia();
            //this.changeProvincia();
            //this.changeCantones();
            //this.changeDistritos();
            //this.getActividades();
            this.tab2 = 1;
            this.cancelarValid = true;
            this.eliminarValid = true;
            this.guardarValid = true;
            this.incluirValid = false;
        },

        save() {
            this.snackValue = false;
            let me = this;
            //this.editedItem.cia = this.strCia;
            this.modeloCia.cia = this.editedItem;
            this.modeloCia.grupoSorteos = this.grupoSorteos;

            if (this.editedIndex > -1) {
                axios
                    .post("/api/Tiempos/UpdateModeloCia", this.modeloCia)
                    .then(function () {
                        me.snackText = "Registro modificado satisfactoriamente";
                        me.snackValue = true;
                        me.getData();
                    })
                    .catch(function (error) {
                        console.log(error);
                        // me.saved(false);
                    });
            } else {
                axios
                    .post("/api/Tiempos/InsertModeloCia", this.modeloCia)
                    .then(function () {
                        me.snackText = "Registro agregado satisfactoriamente";
                        me.snackValue = true;
                        me.getData();
                    })
                    .catch(function (error) {
                        console.log(error);
                        // me.saved(false);
                    });
            }
            this.cancelarValid = true;
            this.eliminarValid = true;
            this.guardarValid = true;
            this.incluirValid = false;
            this.snackValue = false;
            //this.changeEsReceptor();
        },

        deleteItem() {
            this.snackValue = false;
            let me = this;
            if (confirm("¿Está seguro de que desea eliminar el articulo?")) {
                axios
                    .delete("api/Tiempos/deleteClientes?cia=" + this.editedItem.cedula)
                    .then(function () {
                        me.getData();
                    })
                    .catch(function (error) {
                        console.log(error);
                        // me.saved(false);
                    });
                this.cerrar();
                this.tab2 = 0;
                this.esRec = false;
            }
        },

        closed() {
            this.snackValue = false;
            this.showNewData = false;
            this.dialog = false;
        },

        cerrar() {
            this.snackValue = false;
            this.dialog = false;
            this.$nextTick(() => {
                this.editedIndex = -1;
                this.editedItem = Object.assign({}, this.defaultItem);
                this.valid = false;
                this.cancelarValid = false;
                this.eliminarValid = false;
                this.guardarValid = false;
                this.incluirValid = true;
            });
        },

        onImageChange(ev) {
            this.tempFile = ev;
            this.editedItem.certificado = ev.name;
        },

        onChangeCiaImage(ev) {
            this.tempFileImage = ev;
            this.editedItem.imagePath = ev.name;
        },

        incluir() {
            this.$nextTick(() => {
                this.editedIndex = -1;
                this.editedItem = Object.assign({}, this.defaultItem);
                this.cancelarValid = true;
                this.eliminarValid = false;
                this.guardarValid = true;
                this.incluirValid = false;
                this.esRec = false;
                this.getSorteos();
            });
        },
    },
};
</script>

<style scoped>
.reporte-container {
    padding-bottom: 60px;
}

/* Glassmorphism Styles */
.glass-card {
    background: rgba(255, 255, 255, 0.7) !important;
    backdrop-filter: blur(12px) !important;
    border: 1px solid rgba(255, 255, 255, 0.3) !important;
}

.theme--dark .glass-card {
    background: rgba(30, 30, 46, 0.8) !important;
    border: 1px solid rgba(255, 255, 255, 0.1) !important;
}

.glass-btn {
    background: rgba(25, 118, 210, 0.1) !important;
}

.glass-btn-error {
    background: rgba(244, 67, 54, 0.1) !important;
}

.header-glass {
    background: rgba(25, 118, 210, 0.03);
}

.theme--dark .header-glass {
    background: rgba(255, 255, 255, 0.02);
}

.border-bottom {
    border-bottom: 1px solid rgba(0,0,0,0.05);
}

.theme--dark .border-bottom {
    border-bottom: 1px solid rgba(255,255,255,0.05);
}

/* Modern Inputs */
.modern-input >>> .v-input__control > .v-input__slot {
    background: rgba(255, 255, 255, 0.5) !important;
    backdrop-filter: blur(4px);
}

.theme--dark .modern-input >>> .v-input__control > .v-input__slot {
    background: rgba(0, 0, 0, 0.2) !important;
}

/* Table Styling */
.premium-table {
    background: transparent !important;
}

.premium-table >>> th {
    background: rgba(0, 0, 0, 0.02) !important;
    font-weight: 800 !important;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    font-size: 0.75rem !important;
}

.theme--dark .premium-table >>> th {
    background: rgba(255, 255, 255, 0.05) !important;
}

.premium-table >>> tr:hover {
    background: rgba(25, 118, 210, 0.05) !important;
}

/* Text Utilities */
.letter-spacing-1 {
    letter-spacing: 1px;
}

/* Animations */
.animate-fade-in {
    animation: fadeIn 0.4s ease-out;
}

.shadow-soft {
    box-shadow: 0 4px 20px rgba(0,0,0,0.08) !important;
}

@keyframes fadeIn {
    from { opacity: 0; transform: translateY(10px); }
    to { opacity: 1; transform: translateY(0); }
}

/* Theme Aware Dialog/Card */
.theme-aware-dialog {
    border-radius: 24px !important;
}

.theme-aware-card {
    background-color: var(--v-background-base, #ffffff) !important;
}

.theme--dark .theme-aware-card {
    background-color: var(--v-background-base, #1e1e2e) !important;
}

/* Legacy Overrides */
.cd {
    overflow: scroll;
}

.v-tabs-items {
    overflow: auto;
}

.botonSalir {
    position: fixed;
    top: 5px;
    right: 5px;
}
</style>